export default __webpack_public_path__ + "static-bigflip/media/copy-v2.389b1aa2.png";